class Team {

  constructor(data) {
    Utils.autoFeed(this, ['id', 'name', 'kind', 'alert', 'displayed'], data);

    this.children = [];

    if (data.children) {
      for (let i = 0 ; i < data.children.length ; i++) {
        let subTeam = new Team(data.children[i]);
        this.children.push(subTeam);
      }
    }

    this._online_count = 0;
  }

  get online_count() {
    if (this.kind == "many") return this._online_count;
    else return 1;
  }

  set online_count(n) {
    this._online_count = n;
    let span = Dom.findById('widget', 'slaask-widget-online-count');
    if (span) span.innerHTML = this.online_count;
  }

}
